import {Injectable, EventEmitter, OnDestroy, Inject} from '@angular/core';
import {NavigationEnd, NavigationExtras, NavigationStart, Router} from '@angular/router';
import {DOCUMENT, Location} from '@angular/common';
import {Store} from '@ngrx/store';
import {selectHistoriaNawigacji} from '../../store/historia-nawigacji/historia-nawigacji.selectors';
import {filter, Subscription} from 'rxjs';
import {aktualizujHistorieNawigacji} from '../../store/historia-nawigacji/historia-nawigacji.actions';

@Injectable()
export class NavigationService implements OnDestroy {

  private historySubscription!: Subscription;
  private routerSubscription!: Subscription;
  private history: string[] = [];
  private routerEvent = new EventEmitter();

  constructor(
    private readonly router: Router,
    private readonly location: Location,
    private readonly store: Store,
    @Inject(DOCUMENT) private readonly document: Document
  ) {
    this.navigationHistoryListener();
    this.routerListener();
  }

  get getRouterEvent(): EventEmitter<any> {
    return this.routerEvent;
  }

  private navigationHistoryListener(): void {
    this.historySubscription = this.store.select(selectHistoriaNawigacji).subscribe(({ historia }) => {
      this.history = historia;
    });
  }

  private routerListener(): void {
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart && event.navigationTrigger === 'popstate') {
        this.backButtonEventHandler();
      }
      if (event instanceof NavigationEnd) {
        this.navigationEndEventHandler(event.urlAfterRedirects);
      }
    })
  }

  private backButtonEventHandler(): void {
    this.router.navigateByUrl(this.getCurrentUrl());
    this.location.go(this.getCurrentUrl());
    this.location.replaceState('/');
  }

  private navigationEndEventHandler(urlAfterRedirects: string): void {
    this.updateNavigationHistory(urlAfterRedirects);
    this.location.replaceState('/');
    this.routerEvent.emit(null);
  }

  back(): void {
    const historyState = [...this.history];
    historyState.pop()
    if (this.history.length > 0) {
      this.navigateByUrl([historyState[historyState.length - 1]])
      historyState.pop();
    } else {
      this.navigate(['/']);
    }
    this.store.dispatch(aktualizujHistorieNawigacji({ historia: historyState }));
  }

  private updateNavigationHistory(urlAfterRedirects: string): void {
    const updatedHistory = [...this.history];
    if (updatedHistory[updatedHistory.length - 1] !== urlAfterRedirects) updatedHistory.push(urlAfterRedirects);
    this.store.dispatch(aktualizujHistorieNawigacji({ historia: updatedHistory }));
  }

  navigate(command: any[]): void {
    this.router.navigate(command, { replaceUrl: true, skipLocationChange: true });
  }

  navigateByUrl(command: any[]): void {
    this.router.navigateByUrl(command.toString(), { replaceUrl: true, skipLocationChange: true });
  }

  navigateWithExtras(command: any[], extras: NavigationExtras): void {
    extras.skipLocationChange = true;
    this.router.navigate(command, extras);
  }

  getCurrentUrl(): string {
    return this.router.url;
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
    this.historySubscription?.unsubscribe();
  }

  navigateToExternalUrl(link: string): void {
      this.document.location.href = link
  }
}
